<span class="trend-indicator" [class]="trendClass()" mat-flat-button>
  @if (shouldShowTrend()) {
    <mat-icon>{{ trendIcon() }}</mat-icon>
    {{ value() > 0 ? '+' : '' }}
  }
  {{ displayValue() }}
</span>
